import { Switch } from "components/ui/switch";

const initialValue = {
  op: "is",
  value: false,
};

export function BooleanFilter({ value, onChange }) {
  const current = value ?? initialValue;

  return (
    <Switch
      checked={!!current.value}
      onCheckedChange={checked => onChange({ ...current, value: checked })}
    />
  );
}
